export default "__VITE_ASSET__B1heVT2e__"